import { createAction } from 'redux-act'

export const getReportingRequest = createAction('Get Reporting Request')
export const getReportingRequestSuccessful = createAction('Get Reporting Request Successful')
export const getReportingRequestFailure = createAction('Get Reporting Request Failure')
export const pdfDownloadReport = createAction('Pdf Download')

//Operation
export const setFilter = createAction('Set Filter')
